// extracted by mini-css-extract-plugin
module.exports = {"authorDetails":"style-module__authorDetails___sOeZh","authorPhoto":"style-module__authorPhoto___cwlv1"};